import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import {StaticQuery, graphql} from 'gatsby'
import { useLocation } from '@reach/router'


const date = new Date()

function SEO({path, description, lang, languageCode, meta, keywords, title, siteName, schemaMarkup}) {
  const { pathname } = useLocation()
  return (
    <StaticQuery
      query={detailsQuery}
      render={data => {
        const metaDescription = description || data.site.siteMetadata.description
        let longTitle
        
        if (siteName) {
          longTitle = `The Book Of Mormon Musical | Official ${siteName} Website | ${title}`
        } else {
          longTitle = `The Book Of Mormon Musical | ${title}`
        }
        
        let bodyAttributes = {}
        
        
        return (
          <Helmet defaultTitle={title} bodyAttributes={bodyAttributes}>
            <html lang={languageCode}/>
            <title>{longTitle}</title>
            <meta name="title" content={longTitle}/>
            <meta name="description" content={metaDescription}/>
            <meta name="keywords"
                  content="Mormon, Book of Mormon, The Book of Mormon, Broadway, Musical, Matt and Trey, Matt Stone, Trey Parker, Bobby Lopez, South Park, Avenue Q, God Loves Mormons and He Wants Some More, God's favorite musical, God Loves Mormons, Mormon Mission, Latter Day Saints, LDS, Salt Lake City, Joseph Smith, Maroni, Angel Maroni, Brigham Young, New York, God"/>
            <meta name="author" content="Matt Stone and Trey Parker"/>
            <meta httpEquiv="content-language" content={languageCode}/>
            <meta name="distribution" content="GLOBAL"/>
            <meta name="revisit-after" content="1 days"/>
            <meta name="robots" content="all, index, follow"/>
            <meta name="language" content={languageCode}/>
            <meta name="copyright" content={`The Book Of Mormon ${date.getFullYear()}`}/>
            <meta name="google-translate-customization"
                  content="8422e3cb0600d994-e917424235dd25ac-g8cf9845439fe4929-15"/>
            <meta name="HandheldFriendly" content="True"/>
            <meta name="MobileOptimized" content="320"/>
            <meta name="viewport"
                  content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
            <meta name="apple-mobile-web-app-status-bar-style" content="black"/>
            <meta name="format-detection" content="telephone=no"/>
            <meta name="msapplication-TileColor" content="#123456"/>
            <meta name="msapplication-square150x150logo" content="/images/square.jpg"/>
            
            
            {/* Facebook tags */}
            <meta property="og:title" content={longTitle}/>
            <meta property="og:type" content="website"/>
            <meta property="og:url" content={data.site.siteMetadata.siteUrl + pathname}/>
            <meta property="og:description" content={metaDescription}/>
            <meta property="og:site_name" content={data.site.siteMetadata.title}/>
            <meta property="og:language" content="en-GB"/>
            <meta property="og:image" content={`${data.site.siteMetadata.siteUrl}/images/share-banner.jpg`}/>
            
            {/* Twitter tags */}
            <meta name="twitter:card" content="summary"/>
            <meta name="twitter:title" content={longTitle}/>
            <meta name="twitter:description" content={metaDescription}/>
            <meta name="twitter:creator" content={data.site.siteMetadata.author}/>
            
            <link rel="apple-touch-icon" sizes="180x180"
                  href={`${data.site.siteMetadata.siteUrl}/favicons/apple-touch-icon.png`}/>
            <link rel="icon" type="image/png" sizes="32x32"
                  href={`${data.site.siteMetadata.siteUrl}/favicons/favicon-32x32.png`}/>
            <link rel="icon" type="image/png" sizes="16x16"
                  href={`${data.site.siteMetadata.siteUrl}/favicons/favicon-16x16.png`}/>
            <link rel="manifest" href={`${data.site.siteMetadata.siteUrl}/favicons/site.webmanifest`}/>
            <meta name="msapplication-TileColor" content="#da532c"/>
            <meta name="theme-color" content="#ffffff"/>
            <link rel="image_src" href={`${data.site.siteMetadata.siteUrl}/images/share-banner.jpg`}/>
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
            <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600&display=swap" rel="stylesheet"></link>
            <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.3.1/css/all.css"
                  integrity="sha384-mzrmE5qonljUremFsqc01SB46JvROS7bZs3IO2EmfFsd15uHvIt+Y8vEf7N7fWAU"
                  crossOrigin="anonymous"/>
            
            
            {/* <link rel="alternate" hrefLang="en-GB" href={`https://thebookofmormonmusical.com/${pathname}`}/>
            <link rel="alternate" hrefLang="en-US" href="https://bookofmormonbroadway.com/"/> */}
             {schemaMarkup && (
                <script type="application/ld+json">
                  {JSON.stringify(schemaMarkup)}
                </script>
              )}
          </Helmet>
        )
      }}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  keywords: [],
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.array,
  keywords: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string.isRequired,
}

export default SEO

const detailsQuery = graphql`
	query DefaultSEOQuery {
		site {
			siteMetadata {
				title
				description
				author
				siteUrl
			}
		}
	}
`
